import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import './StoryBand.css';

// Import local assets
import spices6Img from '../assets/spices6.jpg';
import spice5Img from '../assets/spice5.jpg';

const StoryBand = () => {
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["start end", "end start"]
  });

  const rotate = useTransform(scrollYProgress, [0, 1], [0, 10]);
  const scale = useTransform(scrollYProgress, [0, 0.5], [0.9, 1]);

  return (
    <section className="story-band" ref={targetRef}>
      {/* Automatic Infinite Ribbon */}
      <div className="ribbon-wrapper">
        <motion.div
          className="ribbon-track"
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            duration: 60,
            repeat: Infinity,
            ease: "linear"
          }}
        >
          {[...Array(20)].map((_, i) => (
            <div key={i} className="ribbon-item">
              TRADITION • QUALITY • PURITY • HAND-GROUND • AUTHENTIC • FAMILY RECIPE •
            </div>
          ))}
        </motion.div>
      </div>

      <div className="container">
        <div className="story-inner">
          {/* Parallax Image Stack */}
          <div className="story-images">
            <motion.div className="story-img-stack" style={{ scale, rotate }}>
              <div className="story-img-primary">
                <img src={spices6Img} alt="Traditional Stone Grinding" />
                <div className="img-overlay-soft" />
              </div>
              <motion.div
                className="story-img-secondary"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                <img src={spice5Img} alt="Fresh Spices" />
                <div className="story-img-badge">
                  <span className="badge-num">19+</span>
                  <span className="badge-label">Years of Legacy</span>
                </div>
              </motion.div>
            </motion.div>

            {/* Floating Decoration */}
            <div className="story-deco-circle-1" />
          </div>

          {/* Content */}
          <div className="story-content">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <span className="section-tag">Our Philosophy</span>
              <h2 className="story-title">The Rhythm of <span className="gradient-text">Stone</span> and Spice</h2>
              <p className="story-text">
                While the world moved to high-speed grinders, we chose to stay. The slow,
                rhythmic crush of stone preserves the soul of the spice — its essential
                oils and delicate aroma.
              </p>
              <p className="story-text-sub">
                It’s not just a process; it’s a tribute to the grandmothers who knew that
                real flavor cannot be rushed.
              </p>
            </motion.div>

            {/* Stats / Timeline */}
            <div className="story-timeline">
              <div className="timeline-item">
                <span className="timeline-year gradient-text">2005</span>
                <span className="timeline-label">The First Stone</span>
              </div>
              <div className="timeline-item">
                <span className="timeline-year gradient-text">500+</span>
                <span className="timeline-label">Partner Farmers</span>
              </div>
            </div>

            <motion.a
              href="/story"
              className="btn-outline-premium"
              whileHover={{ x: 10 }}
              data-cursor
            >
              Read Our Full Heritage
              <span className="arrow">→</span>
            </motion.a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoryBand;
